export default "__VITE_ASSET__C0hhq1ah__"